import {
  CardStyleInterpolators,
  createStackNavigator,
} from "@react-navigation/stack";
import { useNavigation } from "@react-navigation/native";
import * as React from "react";
import { useState } from "react";

import ReceiptScreen from "../../screens/receipt/ReceiptScreen";

import { WorkListTabParamList } from "../../types";
import { HeaderLeft } from "../../components/header/LeftHeader";
import { SCREENS } from "../../constants/Screens";
import { ReceiptHeader } from "../../components/header/ReceiptHeader";
import { WorkListHeader } from "../../components/header/WorkListHeader";
import WorkListScreen from "../../screens/workList/WorkListScreen";

//受領一覧
const WorkListTabStack = createStackNavigator<WorkListTabParamList>();
export function WorkListTabNavigator() {
  const navigation: any = useNavigation();
  window.functions.openDrawer = () => navigation.openDrawer();

  const [confChecked, setConfChecked] = useState(false);
  window.functions.setConfChecked = setConfChecked;

  React.useEffect(() => {
    const unsubscribe = navigation.addListener("tabPress", (e: any) => {
      window.reloadFlag = true;
    });
    return unsubscribe;
  }, [navigation]);

  return (
    <WorkListTabStack.Navigator
      screenOptions={{
        cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
      }}
    >
      <WorkListTabStack.Screen
        name={SCREENS.WORKLIST.WORKLIST as keyof WorkListTabParamList}
        component={WorkListScreen}
        options={{
          headerTitle: "一覧",
          headerLeft: HeaderLeft,
          headerRight: (props) => WorkListHeader(props),
        }}
      />
    </WorkListTabStack.Navigator>
  );
}
